module.exports = __webpack_public_path__ + "img/submit-button.02cb32f0.png";